import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";

export const useGetTicketMessages = (
    ticketID: number | string | null | undefined,
    queryParams: object = {}
) => {
    return useQuery({
        queryKey: ["tickets", ticketID, "messages", queryParams],
        queryFn: async () => {
            const response = await ticketsService.getMessages(ticketID as number | string, queryParams);
            return response.data?.rows || [];
        },
        enabled: Boolean(ticketID),
        refetchOnWindowFocus: false,
    });
};
